import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f68a912"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding":"0"} }

import { toRefs, watch } from 'vue';
import { useKeepaliveStore } from '../store/index';


export default /*#__PURE__*/_defineComponent({
  __name: 'zs-manage-oss-layout',
  setup(__props) {

const { keepaliveNames } = toRefs(useKeepaliveStore());
watch(keepaliveNames, newVal => {
  console.log('newVal', newVal);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view, { style: {"width":"100%","height":"100%","position":"relative"} }, {
      default: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_KeepAlive, {
          include: [..._unref(keepaliveNames)]
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ], 1032, ["include"]))
      ]),
      _: 1
    })
  ]))
}
}

})